import { render, staticRenderFns } from "./HomeInbox.vue?vue&type=template&id=21698474&"
import script from "./HomeInbox.vue?vue&type=script&lang=js&"
export * from "./HomeInbox.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports